import {ButtonSeeker, IconSeekers} from "ui-seeker/core";
import {useAjaxButton} from "./@hooks";
import * as React from "react";

export default function AppAjaxButtonSeeker({
        urlAjax = null,
        data = null,
        label = "Submit",
        icon,
        className,
        disabled,
        size,
        method = "GET",
        onAjax = () => {},
        customToast = false
    }) {
    const { onClick } = useAjaxButton();

    return <ButtonSeeker
        onClick={() => onClick({urlAjax, data, method, onAjax, customToast})}
        className={className}
        disabled={disabled}
        size={size}>

        {icon && <IconSeekers icon={icon} iconType="fontAwesome" className="mr-8"/>}
        {label}

    </ButtonSeeker>
}
